import styled from 'styled-components';
import Box from '@material-ui/core/Box';

const Wrapper = styled(Box)`
  ${({ theme }) => `
  .MuiTypography-body1 {
    font-size: 18px;
  }
  .select__menu {
    height: 200px;
    overflow: auto;
    .select__menu-list {
      height: 210px;
      max-height: 100%;
    }
  }
  .filepond--wrapper {
    .filepond--drop-label label {
      color: ${theme.colors.PRIMARY_CONTRAST};
      opacity: 1;
    }
  }
  .subheaderSection {
    padding: 11px 20px;
    margin-top: 10px !important;
  }
  .fieldSection {
    margin-bottom: 16px;
    .MuiInputBase-root{
    margin-bottom: 0;
    }
    .MuiFormLabel-root{
      padding-right: 7px !important;
      line-height: 1.2;
    }
  }
  form {
    div:last-child {
      justify-content: center;
      #button {
        // width: 210px;
        margin-top: 0;
      }
    }
  }
  `}
`;
const UploadWrapper = styled(Box)`
`;
const PopupUpload = styled(Box)``;
const Styled = { Wrapper, UploadWrapper, PopupUpload };

export default Styled;
